import $api2 from '@/plugins/axiosInstance2.js'

const actions = {
  GET_EXPORT_CONTRACTS: {
    root: true,
    handler(namespacedContext, payload) {
      return $api2({ method: 'get', url: '/admin/export-contract', params: payload })
        .then(result => result.data)
    }
  },
  GET_EXPORT_CONTRACT_PRESET_LIST: {
    root: true,
    handler(namespacedContext, payload) {
      return $api2({ method: 'get', url: '/admin/export-contract-preset', params: payload })
        .then(result => result.data)
    }
  },
  GET_EXPORT_CONTRACT_PRESET: {
    root: true,
    handler(namespacedContext, payload) {
      return $api2({ method: 'get', url: `/admin/export-contract-preset/${payload.id}` })
        .then(result => result.data)
    }
  },
  POST_EXPORT_CONTRACT_PRESET: {
    root: true,
    handler(namespacedContext, payload) {
      return $api2({ method: 'post', url: '/admin/export-contract-preset', data: payload.params })
        .then(result => result.data)
    }
  },
  PUT_EXPORT_CONTRACT_PRESET: {
    root: true,
    handler(namespacedContext, payload) {
      return $api2({ method: 'put', url: `/admin/export-contract-preset/${payload.id}`, data: payload.params })
        .then(result => result.data)
    }
  },
  DELETE_EXPORT_CONTRACT_PRESET: {
    root: true,
    handler(namespacedContext, payload) {
      return $api2({ method: 'delete', url: `/admin/export-contract-preset/${payload.id}` })
        .then(result => result.data)
    }
  },
  POST_EXPORT_JOB_GENERATE: {
    root: true,
    handler(namespacedContext, payload) {
      return $api2({ method: 'post', url: '/admin/export-job/generate', data: payload.params })
        .then(result => result.data)
    }
  },
}

export default {
  namespaced: true,
  state: {},
  mutations: {},
  actions,
  getters: {},
}
